import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <div className='cotainer'>
            <h1>Welcome</h1><br></br>
            <h1>To</h1><br></br>
            <h1>Coder</h1><br></br>
            <h1>E-Learnig</h1><br></br>
            <h1>Platform</h1><br></br>
            <h3>We believe in you......</h3><br></br>
            <h3>Because You Are a Genius</h3><br></br>
        </div>
    );
};

export default Home;